var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.dataLoading,
          expression: "dataLoading",
        },
      ],
      staticClass: "bg",
      style: _vm.bgStyle,
    },
    [
      !_vm.dataLoading
        ? _c("Preview", {
            attrs: {
              "component-data": _vm.mainCanvasComponentData,
              "canvas-style-data": _vm.canvasStyleData,
              "back-screen-shot": _vm.backScreenShot,
              "panel-info": _vm.panelInfo,
            },
            on: { mainHeightChange: _vm.mainHeightChange },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }